// SOCKET CONNECTION CONFIG
export const SOCKET_MAX_RECONNECT_ATTEMPTS = 8;
export const SOCKET_RECONNECT_DELAY_BASE = 1000;
export const SOCKET_RECONNECT_DELAY_MAX = 30000;

// SOUND_EFFECTS
export const SOUND_SUCCESS = [
  "success1",
  "success2",
  "success3",
  "success4",
  "success5",
] as const;
export const SOUND_SNAPPED = [
  "playerSnap1",
  "playerSnap2",
  "playerSnap3",
  "playerSnap4",
  "playerSnap5",
] as const;
export const SOUND_BONUS = [
  "bonus1",
  "bonus2",
  "bonus3",
  "bonus4",
  "bonus5",
] as const;
